<template>
  <section id="section-3" class="left-body-container">
    <div class="header bg-gradient-success pb-6 pb-8 pt-5 pt-md-8">
      <h4 class="profile-section-title">
        <i class="ni ni-diamond"></i> امتیاز ها
      </h4>
      <div class="row align-items-center justify-content-center">
        <div class="d-block d-lg-none p-2"></div>
        <div class="col-lg-6">
          <div class="row justify-content-center gift-card">
            <loyalty-card />
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7">
      <div class="row card">
        <div class="col-12">
          <div class="card-body">
            <score-chart />
            <p>
              واحد امتیاز در باشگاه مشتریان ما "دریک" ( Derick) است و هر امتیاز
              با یک سکه ی دریک برابر خواهد بود . دریک نخستین واحد پول در ایران
              باستان است و ریشه در کهن ترین بخشهای تاریخی و فرهنگی ما دارد .
            </p>

            <p>
              دریک واحد پولی باشگله مشتریان ماست و ارزشی در خارج از خدمات این
              باشگاه ندارد ولی بر آنیم تا در گامهای بعدی با گسترش شبکه ی خدمات
              خود امکان استفاده از آن برای خرید دیگر کالاها و خدمات شایسته ی
              هموندان این باشگاه گسترده تر کنیم . بنابراین ارزش هر یک دریک می
              تواند تغییر کند ولی هم اکنون ارزش هر دریک معادل 10 هزار تومان است
              و شما می توانید تا سقف امتیاز یا دریک خود در خرید خدمات این باشگاه
              بهره ببرید . علاوه بر این بسته به موجودی امتیاز یا دریک خود و
              همچنین تالاری که در آن قرار دارید هر از گاهی پیشنهادات ویژه برای
              استفاده از خدمات این باشگاه شامل تخفیف ها یا خدمات رایگان دریافت
              خواهید کرد .
            </p>
            <h3>از چه راه هایی امتیاز کسب کنیم ؟</h3>
            <p>
              شما می توانید در باشگاه مشتریان داریوش از راه های گوناگونی امتیاز
              به دست آورید . مهمترین آن خرید خدمات از این باشگاه است ولی ما به
              پاس هر بازخوردی که از شما در راستای بهینه سازی کسب و کارهای باشگاه
              داریوش دریافت کنیم امتیاز هدیه خواهیم کرد. از شرکت در نظر سنجی ها
              گرفته تا مشارکت در رویدادهایی که در بزنگاههای گوناگون ترتیب خواهیم
              داد .
            </p>
          </div>
        </div>
        <div class="col-12 row get-score-ways">
          <div class="col-md-4">
            <div class="get-score-img">
              <img src="/img/ichecklist.png" alt="" />
            </div>
            <h3>ثبت سفارش</h3>
            <p>
              شما با خرید از هریک از مراکز زیر پوشش این شرکت و بسته به مبلغی که
              پرداخت می کنید دریک دریافت می کنید .
            </p>
          </div>
          <div class="col-md-4">
            <div class="get-score-img">
              <img src="/img/iprogrammer.png" alt="" />
            </div>
            <h3>فعالیت در رویدادهای ویژه</h3>
            <p>
              در طول سال و در رویدادهایی ویژه که پیش تر اعلام خواهد شد، امتیاز های ارزشمندی به کاربران گرامی داده خواهد شد . 
               </p>
          </div>
          <div class="col-md-4">
            <div class="get-score-img">
              <img src="/img/isurvey.png" alt="" />
            </div>
            <h3>شرکت در نظرسنجی</h3>
            <p>
              ما پس از استفاده ی شما از هریک از خدمات این باشگاه  از شما نظرات و توضیحات مفید و سازنده را انتظار داریم که به پاس دریافت آن به شما  دریک اهدا خواهیم کرد .  .
                </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7" style="padding-top: 100px">
      <div class="row card">
        <div class="card-header border-0">
          <div class="row align-items-center">
            <div class="col">
              <h3 class="mb-0">امتیازات</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <img
            src="/img/swipe-helper.gif"
            class="scroll-guide d-md-none"
            alt="راهنمای اسکرول"
          />
          <div class="table-responsive">
            <table class="table tablesorter" v-if="!isLoading">
              <thead class="thead-light">
                <tr>
                  <th>تاریخ</th>
                  <th>امتیاز</th>
                  <th>مانده امتیاز</th>
                  <th>مهلت اعتبار</th>
                  <th>ت</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in customerTransactionList">
                  <tr>
                    <td>
                      {{ item.transactionDate }}
                    </td>
                    <td v-if="item.scoreType === 0" style="color: green">
                      {{ item.score }}
                      <span> +</span>
                    </td>
                    <td v-if="item.scoreType === 1" style="color: red">
                      {{ item.score }}
                      <span> -</span>
                    </td>
                    <td>{{ item.scoreBalance }}</td>
                    <td>
                      {{ item.expireDate }}
                    </td>

                    <td>{{ item.description }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from "../store/index";
import loadingBar from "../../../components/loading/pdkLoadingBar";
import LoyaltyCard from "../../../components/club/LoyaltyCard";
import ScoreChart from "../../../components/club/ScoreChart";

export default {
  name: "Scors",
  store,
  components: { loadingBar, LoyaltyCard, ScoreChart },
  data() {
    return {
      isLoading: false,
      hasShowResult: false,
      score: 0,

      segment: "bronz",
      scorePercent: "",
      persent: "",
      descptData: "",
      card: "",
      userId: "",
      customerScoreList: [],
      customerTransactionList: [],
    };
  },
  computed: {
    GetScore() {
      return this.$store.getters.GetCustomerClubData.score;
    },
  },
  created() {
    this.userId = localStorage.getItem("UserId");
    // this.setData();
    //this.getCustomerScoresByProfileId();
    this.getCustomerTransactionsByProfileId();
  },

  methods: {
    async setData() {
      this.persent = this.$store.getters.GetUserScore;
      this.card = this.$store.getters.GetUserSegment;
      this.scorePercent = (this.persent / 10000) * 100;
      this.scorePercent = this.scorePercent + ",100";

      return this.scorePercent, this.card;
    },
    async getCustomerScoresByProfileId() {
      this.isLoading = true;

      const res = await this.$store.dispatch(
        "getCustomerScoresByProfileId",
        this.userId
      );
      this.customerScoreList = res.data.queryResult;
      this.isLoading = false;
    },
    async getCustomerTransactionsByProfileId() {
      this.isLoading = true;
      const res = await this.$store.dispatch(
        "getCustomerTransactionsByProfileId",
        this.userId
      );
      this.customerTransactionList = res.data.queryResult;
      this.isLoading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.card-body {
  width: 100%;
  table {
    overflow-x: auto;
  }
}
.page-item.active .page-link {
  z-index: 1;
  color: #fff !important;
  background-color: #2a69b1 !important;
  border-color: #2a69b1 !important;
}
.btn-profile {
  width: 180px !important;
}
.btn-align {
  /* text-align: center; */
  margin-top: 20px !important;

  /* padding-right: 70px !important;
  padding-left: 70px !important; */
}
.icon-top {
  margin-top: 38px;
  font-size: 40px;
}
.icon-bottom {
  margin-top: 38px;
  font-size: 22px;
}
.icon-position {
  float: left;
  margin-left: 26px;
}

.td-opened {
  background-color: rgb(24, 159, 226) !important;
  color: white;
}
.loading {
  height: 1000px !important;
  text-align: center !important;
  margin-top: 200px !important;
}
h3 {
  color: #172b4d !important;
}
.loading {
  height: 100px !important;
  text-align: center !important;
  margin-top: 50px !important;
}
.left-body-container {
  .container-fluid {
    margin: 0 5%;
    width: 90%;
  }
  .get-score-ways {
    .col-md-3 {
      padding: 30px;
    }
    .get-score-img {
      text-align: center;
      img {
        width: 20%;
        margin: 15px auto;
      }
      // &::before {
      //   content: " ";
      //   background-image: url(/img/dasher.png);
      //   background-size: contain;
      //   width: 221px;
      //   height: 31px;
      //   position: absolute;
      //   left: -102px;
      //   top: 22%;
      //   z-index: 999;
      // }
    }
    .get-score-img.last-item:before {
      display: none;
    }
    h3 {
      text-align: center;
      margin: 20px 0;
    }
  }
}
.scroll-guide {
  position: absolute;
  width: 50px;
  left: -5px;
  top: 150px;
}
@media (max-width: 478px) {
  .gift-card {
    #card {
      background-size: contain;
      margin-top: 0;
      min-width: initial;
      max-width: 320px;
      margin-right: 4px;
      border-radius: 20px;
      max-height: 205px;
    }
  }
  .table-responsive tr th {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table-responsive tr td {
    text-align: center;
  }
}
</style>    
      